import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import {HttpService} from './http.service';
import {UtilService} from './util.service';
import {LoaderService} from './loader.service';

@Injectable()
export class LoyaltyService {
  private brandSubject = new Subject();
  brandState = this.brandSubject.asObservable();

  constructor(
    private http: HttpService,
    private utilService: UtilService,
    private loaderService: LoaderService
  ) {
  }

  brandInfo(brandInfo): any {
    this.brandSubject.next({brand: brandInfo});
  }

  getProgramTypes() {
    return this.http.get(`/loyalty/getLoyaltyProgramTypes`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getEmployeePointRules() {
    return this.http.get(`/loyalty/getEmployeePointRules`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getBookingTypes() {
    return this.http.get(`/loyalty/getBookingTypes`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  createBrandWizard(data) {
    return this.http.post(`/loyalty/createBrandProgramme`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  createLoyalty(data) {
    return this.http.post(`/loyalty/createLoyaltyProgramme`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  updateLoyalty(data) {
    return this.http.post(`/loyalty/updatedLoyaltyProgram`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getLoyaltyProgram() {
    return this.http.get(`/loyalty/getLoyaltyProgramData`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  saveLoyaltyWebsite(data) {
    return this.http.post(`/loyaltyWebsite/saveLoyaltyWebsite`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  saveLoyaltyWebsiteOtherPages(data) {
    return this.http.post(`/loyaltyWebsite/saveOtherPages`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getHeaderAndFooter(brandId) {
    return this.http.get(`/loyaltyWebsite/getHeaderAndFooter/${brandId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getWebsiteCss(brandId) {
    return this.http.get(`/loyaltyWebsite/getFontColorScheme/${brandId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getWebsiteHeroMemberData(brandId) {
    return this.http.get(`/loyaltyWebsite/getHeroBannerAndNewMemberDataForUser/${brandId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getCatalogRewards(brandId, langId) {
    return this.http.get(`/loyaltyWebsite/getCatalogsByConfiguration/${brandId}/${langId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getCatalogBanner(brandId) {
    return this.http.get(`/loyaltyWebsite/getCatalogBannerConfiguration/${brandId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getOtherPages(brandId) {
    return this.http.get(`/loyaltyWebsite/getOtherPages/${brandId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getBookingWidget(brandId) {
    return this.http.get(`/loyaltyWebsite/getBookingWidget/${brandId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getHeroBannerData(brandId) {
    return this.http.get(`/loyaltyWebsite/getHeroBannerConfiguration/${brandId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getCatalogRules() {
    return this.http.get(`/loyaltyWebsite/getCatalogBannerLayoutsAndRules`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getMemberConfigData(brandId) {
    return this.http.get(`/loyaltyWebsite/getLoyaltyWebsiteMemberUpgradeConfiguration/${brandId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/_services/loyalty.service.ts